export default __webpack_public_path__ + "static/media/Classical.79851cb5.png";